import React from 'react';
import { X, Globe, FileText } from 'lucide-react';

const WeatherModal = ({ 
  setActiveModal, 
  weatherData, 
  setWeatherData, 
  logWeather 
}) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold">Log Weather</h3>
      <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-gray-600">
        <X className="h-5 w-5" />
      </button>
    </div>
    
    <div className="space-y-4">
      <div className="flex gap-2 mb-4">
        <button
          className="flex-1 px-4 py-2 bg-gray-100 text-gray-600 rounded-lg flex items-center justify-center gap-2 opacity-50"
          disabled
        >
          <Globe className="h-4 w-4" />
          Use Weather API
          <span className="text-xs">(Coming Soon)</span>
        </button>
        <button
          className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg flex items-center justify-center gap-2"
        >
          <FileText className="h-4 w-4" />
          Manual Entry
        </button>
      </div>
      
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Wind Force *</label>
          <select
            value={weatherData.windForce}
            onChange={(e) => setWeatherData({...weatherData, windForce: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="">Select...</option>
            {[0,1,2,3,4,5,6,7,8,9,10].map(n => (
              <option key={n} value={n}>Force {n}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Direction</label>
          <select
            value={weatherData.windDir}
            onChange={(e) => setWeatherData({...weatherData, windDir: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="">Select...</option>
            {['N','NE','E','SE','S','SW','W','NW'].map(dir => (
              <option key={dir} value={dir}>{dir}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Sea State</label>
          <select
            value={weatherData.seaState}
            onChange={(e) => setWeatherData({...weatherData, seaState: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="">Select...</option>
            {[0,1,2,3,4,5,6].map(n => (
              <option key={n} value={n}>State {n}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Visibility</label>
          <select
            value={weatherData.visibility}
            onChange={(e) => setWeatherData({...weatherData, visibility: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="">Select...</option>
            <option value="Good">Good (&gt;5nm)</option>
            <option value="Moderate">Moderate (2-5nm)</option>
            <option value="Poor">Poor (0.5-2nm)</option>
            <option value="Fog">Fog (&lt;0.5nm)</option>
          </select>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Barometer (mb)</label>
        <input
          type="text"
          value={weatherData.barometer}
          onChange={(e) => setWeatherData({...weatherData, barometer: e.target.value})}
          placeholder="e.g., 1013"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div className="flex gap-2 pt-4">
        <button
          onClick={() => setActiveModal(null)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={logWeather}
          disabled={!weatherData.windForce}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          Log Weather
        </button>
      </div>
    </div>
  </div>
);

export default WeatherModal;